export const supportedServices = {
  Legal: 'Legal',
  DomainResolution: 'DomainResolution',
} as const
